import { Injectable } from '@angular/core';

import { Http } from '@angular/http';

import { UserData } from './user-data';
import { CommonData } from '../providers/common-data';
import { NativeScriptHttpModule } from "nativescript-angular/http";

@Injectable()
export class HistoryData {
  data: any;
  ppstatusdata : any;

  constructor(public http: Http, public common: CommonData, public userData: UserData) {
    this.ppstatusdata = [];
  }
  clear(){
    if(this.data!=null){
      this.data.length = 0;
    }
  }
  load(tablename, recordid) {
    return new Promise(resolve => {
      if(this.userData.loggedin){
        var data = JSON.stringify({
          table: tablename,
          recordid: recordid,
          token: this.userData.jwt
      });
        this.http.post(this.common.baseurl+'histories/index',data).subscribe(res => {
          this.data = res.json().data;
          //console.log(this.data);
          resolve(this.data);
        }, error => {
          console.log('HTTP Error, no answer history-data.ts');
          console.log(error);
      });

      }
    });
  }


}



// WEBPACK FOOTER //
// ./src/providers/history-data.ts